<div fxLayout="row" fxLayoutAlign=" center" class="input-container">
  <mat-form-field [style.fontSize.px]="16">
    <input matInput type="text" [(ngModel)]="text" [style.fontSize.px]="16" />
  </mat-form-field>
  <nw-icon type="done" [size]="17" (click)="create(text)"></nw-icon>
  <nw-icon type="close" [size]="17" (click)="cancel()"></nw-icon>
</div>
